import { ShopifyProduct } from '@magal/models'

export const filterProducts = (
  products: ShopifyProduct[],
): ShopifyProduct[] => {
  return products.filter((product) => !product.tags.includes('_hidden_product'))
}
